import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-end overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/42de0f5b5a24d342feb4bae537d02068.jpg"
          alt="Adventure wilderness landscape"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-black/40 to-black/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-12 pb-20 md:pb-28">
        <div className="max-w-2xl">
          <span className="inline-block bg-[#C4FF61] text-[#1A1A1A] font-outfit font-semibold text-xs px-4 py-1.5 rounded-full uppercase tracking-widest mb-6 animate-fade-in">
            Premium Outdoor Gear
          </span>
          <h1 className="font-outfit font-black text-white leading-none mb-6">
            <span className="block text-5xl md:text-7xl lg:text-[88px]">CONQUER</span>
            <span className="block text-5xl md:text-7xl lg:text-[88px] text-[#C4FF61]">THE WILD</span>
          </h1>
          <p className="text-white/70 font-inter text-base md:text-lg leading-relaxed mb-8 max-w-lg">
            Premium outdoor gear engineered for extreme conditions and unforgettable adventures. Trusted by serious explorers since 2018.
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Link
              to="/products"
              className="inline-flex items-center gap-2 bg-[#C4FF61] text-[#1A1A1A] font-outfit font-bold px-8 py-4 rounded-full hover:bg-[#a8e84a] transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              Shop Now
              <i className="ri-arrow-right-line"></i>
            </Link>
            <a
              href="#categories"
              className="inline-flex items-center gap-2 border border-white/40 text-white font-outfit font-medium px-8 py-4 rounded-full hover:border-white hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap text-sm"
            >
              View Collections
            </a>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="flex flex-wrap items-center gap-8 mt-14 pt-8 border-t border-white/10">
          {[
            { value: '2,400+', label: 'Products' },
            { value: '48,000+', label: 'Happy Adventurers' },
            { value: '4.9★', label: 'Average Rating' },
            { value: 'Free', label: 'Shipping $75+' },
          ].map((stat) => (
            <div key={stat.label}>
              <p className="font-outfit font-black text-[#C4FF61] text-xl md:text-2xl">{stat.value}</p>
              <p className="font-inter text-white/50 text-xs mt-0.5">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 right-8 hidden md:flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 font-outfit text-xs uppercase tracking-widest rotate-90 origin-center">Scroll</span>
      </div>
    </section>
  );
}
